import { Image as ImageIcon, FileText, Calculator, DraftingCompass } from "lucide-react";

// Single source of truth for plan file types. Keep the keys in sync with
// backend/file_types.py — the backend validates against the same list.
export const FILE_TYPES = [
  { key: "floor_plan", label: "Floor Plan", labelKey: "plan.floorPlan", icon: ImageIcon, defaultPaise: 29900, accept: ".pdf" },
  { key: "boq", label: "Bill of Quantities", labelKey: "plan.boq", icon: FileText, defaultPaise: 19900, accept: ".pdf" },
  { key: "cost", label: "Cost Estimate", labelKey: "plan.cost", icon: Calculator, defaultPaise: 19900, accept: ".pdf" },
  { key: "cad", label: "AutoCAD Drawing", labelKey: "plan.cad", icon: DraftingCompass, defaultPaise: 99900, accept: ".dwg,.dxf" },
];

export const FILE_TYPE_KEYS = FILE_TYPES.map(t => t.key);

const byKey = Object.fromEntries(FILE_TYPES.map(t => [t.key, t]));

export const fileTypeLabel = (key) => byKey[key]?.label ?? key;
export const fileTypeLabelKey = (key) => byKey[key]?.labelKey ?? key;
export const fileTypeIcon = (key) => byKey[key]?.icon ?? FileText;
export const fileTypeAccept = (key) => byKey[key]?.accept ?? ".pdf";
